"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RadioExtended;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactNative = require("react-native");
var _Radio = _interopRequireDefault(require("./Radio"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _styles = require("@sart/styles");
var _excluded = ["selected", "label", "radioLabelStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function RadioExtended(props) {
  var selected = props.selected,
    label = props.label,
    radioLabelStyle = props.radioLabelStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var labelStyle = {
    color: selected ? _styles.colors.feature : _styles.colors.common
  };
  var labelStyles = [styles.label, labelStyle, radioLabelStyle];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_Radio["default"], (0, _extends2["default"])({
    selected: selected
  }, rest)), label && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    width: 12
  }), /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyles
  }, label)));
}
RadioExtended.propTypes = _objectSpread(_objectSpread({}, _Radio["default"].propTypes), {}, {
  label: _propTypes["default"].string
});
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  label: {
    fontSize: 16,
    color: _styles.colors.common
  }
});